export type VerbAnalytics = {
  name: string;
  userCount?: number;
  zapsLive?: number;
  zapsPaused?: number;
  zapsTotal?: number;
};

export enum UsageType {
  action = 'ACTION',
  trigger = 'TRIGGER',
}
